import { useState } from "react";
import { toast } from "sonner";
import { ShieldX } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const RgpdEraseButton = ({ url, who, onDone, testid }) => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user?.is_primary_admin) return null;
  const erase = async () => {
    if (!window.confirm(`Effacer définitivement les données personnelles de ${who} (RGPD) ?\n\nNom, coordonnées et pièces jointes seront supprimés. Seule une trace anonyme est conservée. Action irréversible.`)) return;
    setBusy(true);
    try { await http.post(url); toast.success("Données personnelles effacées"); onDone?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={testid} onClick={erase} disabled={busy} className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-md border border-slate-400 text-slate-700 hover:bg-slate-100 disabled:opacity-60">
      <ShieldX className="h-3.5 w-3.5" />Effacer les données (RGPD)
    </button>
  );
};
